import React, { useEffect,useState } from 'react';
import Modal from '@components/Modal';
import { useQuestionnaireContext } from '@/components/Questionnaire/QuestionnaireProvider';
import { TBody, TD, TH, THead, Table, TableRow } from '@/components/DesignLibrary/Table';
import * as format from '@format';
import { Questionnaire } from '@/typings/Questionnaire';
import { ExpressionVariable } from '@/typings/questionnaires-api-models';
import { FieldValues } from 'react-hook-form';
import s from './DynamicForm.module.scss';

type Props={
  toggleModal: ()=>void;
  fieldData:Questionnaire.Field;
  formData:Questionnaire.Questionnaire;
};

type MapperData={
helper:Questionnaire.Field
key:string;
label:string;
variableName:string;
value:FieldValues;
};

const AutofillExplanationModal : React.FC<Props> = ({toggleModal,fieldData, formData}) => {
  const {formMethods} = useQuestionnaireContext();
  const [variablesData,setVariablesData]=useState<(Pick<ExpressionVariable, "variableName" | "referenceId" | "referenceType" | "selector">[]) | undefined>();
  const [mapperData,setMapperData] = useState<MapperData[]>();

  useEffect(() => {
    if(fieldData?.autofill?.expression?.variables?.length) {
      setVariablesData(fieldData?.autofill?.expression?.variables);
    }
  },[fieldData]);

  useEffect(() => {
    const temp:MapperData[]=[];
    const allvalues = formMethods.getValues();
    variablesData?.forEach((v:Pick<ExpressionVariable, "variableName" | "referenceId" | "referenceType" | "selector">) => {
      formData?.sections?.forEach((f:Questionnaire.Section) => {
        const found = f?.fields?.find((a:Questionnaire.Field) => a?.key===v?.referenceId);
        if(found) {
          const valueOfField = allvalues[found?.key];
          temp.push({
            helper:found,
            key:found?.key,
            label:found?.label,
            value:valueOfField,
            variableName:v?.variableName,
          });
        }
      });
    });
    setMapperData(temp);
  },[variablesData,formData,formMethods]);

  function formatAddressAndCounty(obj:FieldValues):string {
    const addressField = obj.voluntarypetitionforindividualsfilingforbankruptcyfield105;
    let result= `${addressField.line1}, ${addressField.city}, ${addressField.state} - ${addressField.zip}
                  County: ${obj.voluntarypetitionforindividualsfilingforbankruptcyfield106}`;
    if (obj.voluntarypetitionforindividualsfilingforbankruptcyfield107) {
      result += `\nCountry: ${obj.voluntarypetitionforindividualsfilingforbankruptcyfield107}`;
    }

    if (obj.voluntarypetitionforindividualsfilingforbankruptcyfield109) {
      result += `\nAdditional Info: ${obj.voluntarypetitionforindividualsfilingforbankruptcyfield109}`;
    }
    return result;
  }

  function removePrefix(text:string):string {
    return text.replace(/^[^A-Z]+/, '');
  }

  const valueFormatter = (value:MapperData):string => {
    // currently works for median, yet to build a generic formatter
    if(value?.helper?.type==='currency') {
      return format.price.withCurrency(value?.value?.amount, value?.value?.currency);
    }
    if(typeof value?.value==='string') {
      return value?.value;
    }
    if(typeof value?.value === 'number') {
      return value?.value;
    }
    if(value?.variableName==='address' && value?.value?.length) {
      return formatAddressAndCounty(value?.value[0]);
    }
    return '-';
  };

  return (
    <Modal hasPadding title={'Data used for calculation'} onClose={toggleModal} >
      <div className={s.modalContent}>
        <Table>
          <THead>
            <TableRow>
              <TH label='Properties'></TH>
              <TH label='Values'></TH>
            </TableRow>
          </THead>
          <TBody>
            {mapperData?.map((v:MapperData,index:number) => (
              <TableRow key={index}>
                <TD label={removePrefix(v?.label)}></TD>
                <TD label={valueFormatter(v)}></TD>
              </TableRow>
            ))}
          </TBody>
        </Table>
      </div>
    </Modal>
  );
};
export default AutofillExplanationModal;